/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyersdescription2Inputs */

const en_placeflyersdescription2 = /** @type {(inputs: Placeflyersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to print. Pick a size and style – the print dialog can also save the flyer as a PDF.`)
};

const de_placeflyersdescription2 = /** @type {(inputs: Placeflyersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig zum Ausdrucken. Wähl Größe und Stil – im Druckdialog kannst du den Flyer auch als PDF speichern.`)
};

/**
* | output |
* | --- |
* | "Ready to print. Pick a size and style – the print dialog can also save the flyer as a PDF." |
*
* @param {Placeflyersdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyersdescription2 = /** @type {((inputs?: Placeflyersdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyersdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyersdescription2(inputs)
	return de_placeflyersdescription2(inputs)
});
export { placeflyersdescription2 as "placeFlyersDescription" }